export default __webpack_public_path__ + "static/media/sec2.ee59f6e9.png";